import { Card, Typography, Tag, Space } from "antd";
import { useBlog, useListBlogCategories } from "api/blog";
import { FC, useMemo } from "react";
import { useParams } from "react-router-dom";

const CategoryList: FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data } = useBlog({ id }, { enabled: !!id });
  const { data: allCategories } = useListBlogCategories();

  const categories = useMemo(() => {
    if (
      !Array.isArray(allCategories) ||
      !data ||
      !Array.isArray(data?.categories)
    ) {
      return [];
    }
    return allCategories.filter(
      (category) => data.categories.findIndex((i) => i === category._id) > -1
    );
  }, [allCategories, data]);

  return (
    <Card>
      <Space direction="vertical" size={12}>
        <Typography>Tags</Typography>
        <Space direction="horizontal" size={8} style={{ flexWrap: "wrap" }}>
          {categories.map((category) => {
            return <Tag key={category._id}>{category.name}</Tag>;
          })}
        </Space>
      </Space>
    </Card>
  );
};

export default CategoryList;
